"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Popper", {
  enumerable: true,
  get: function get() {
    return _Popper.Popper;
  }
});
Object.defineProperty(exports, "Manager", {
  enumerable: true,
  get: function get() {
    return _Manager.Manager;
  }
});
Object.defineProperty(exports, "Reference", {
  enumerable: true,
  get: function get() {
    return _Reference.Reference;
  }
});
Object.defineProperty(exports, "usePopper", {
  enumerable: true,
  get: function get() {
    return _usePopper.usePopper;
  }
});

var _Popper = require("./Popper");

var _Manager = require("./Manager");

var _Reference = require("./Reference");

var _usePopper = require("./usePopper");


//////////////////
// WEBPACK FOOTER
// ./~/react-popper/lib/cjs/index.js
// module id = 1985
// module chunks = 0